import PropTypes from 'prop-types';
import React, { useState, useMemo } from 'react';
import { SponsorshipCard } from '../../01-Atoms/SponsorshipCard/SponsorshipCard';
import { Divider } from '../../01-Atoms/Divider/Divider';
import './SponsorshipSideBar.scss';

export const SponsorshipSideBar = ({ paymentType, sponsorshipItems, onCartAction, openByDefault = true }) => {
  const [isOpen, isOpenSet] = useState(openByDefault)
  const [showEditMode, showEditModeSet] = useState(false)

  const handleClick = () => {
    isOpenSet(!isOpen);
  }

  const monthlyTotal = sponsorshipItems.filter(item => paymentType === 'monthly').map(item => item.amount).reduce((sum, val) => sum + val, 0).toFixed(2)
  const oneOffTotal  = sponsorshipItems.filter(item => paymentType === 'single').map(item => item.amount).reduce((sum, val) => sum + val, 0).toFixed(2)

  const question = 'Hide / show sponsorship details'
  const id = useMemo(() => Math.random().toString(36).substring(7), [])


  return (
    <>
      <div className='m-sponsorship-sidebar__container o-sidebar'>
        <div className="m-sponsorship-sidebar">
          <h2 className="m-sponsorship-sidebar__heading">Your order</h2>
          {sponsorshipItems.map((item, i) => {
                return (
                  <div className="m-sponsorship-sidebar__items-wrapper" key={i}>
                    <div>{item.description} @ £{item.amount.toFixed(2)}</div>
                  </div>
                )
              }
          )}
          {monthlyTotal && monthlyTotal > 0 ?
          <div className="m-sponsorship-sidebar__total-wrapper">
            <span>Total monthly:</span>
            <span>£{monthlyTotal}</span>
          </div>
          : ''}
          {oneOffTotal && oneOffTotal > 0 ?
          <div className="m-sponsorship-sidebar__total-wrapper">
            <span>Total one-off amount:</span>
            <span>£{oneOffTotal}</span>
          </div>
          : ''}

        <div className={`m-sponsorship-sidebar__details ${isOpen && "open"}`} id={`toggle-element-${id}`} aria-expanded={isOpen}> {sponsorshipItems.map((item, i) => {
                return (
                  <SponsorshipCard key={i}
                    giftRecipient={item.is_gift}
                    giftRecipientName={item.recipient_first_name}
                    paymentType={paymentType}
                    sponsorshipTypeImageSrc={item.image.src}
                    sponsorshipTypeImageAltText={item.image.alt}
                    sponsorshipTypeDescription={item.type_description}
                    sponsorAmount={item.amount}
                    sponsorshipItemDescription={item.description}
                    itemQuantity={1}
                    showEditActions={showEditMode}
                                   onEdit={() => onCartAction('edit', i)}
                                   onRemove={() => onCartAction('remove', i)}
                  />
                )
              })
            }
          </div>

          <div className='m-sponsorship-sidebar__actions'>
            <button onClick={() => showEditModeSet(!showEditMode)}>{showEditMode ? 'Done' : 'Make changes'}</button>
          </div>

          <button
            className={isOpen ? 'm-sponsorship-sidebar__toggle-button open' : 'm-sponsorship-sidebar__toggle-button'}
            id={`toggle-element-${id}-label`}
            aria-controls={`toggle-element-${id}`}
            aria-expanded={isOpen}
            onClick={handleClick}>
            {isOpen ? <p>Hide sponsorship details</p> : <p>Show sponsorship details</p>}
            <span className="m-sponsorship-sidebar__toggle-button-icon" />
          </button>

        </div>
        <Divider
          dividerColor='off-white'
          dividerCurveColor='white'
        />
      </div>
    </>
  )
}


SponsorshipSideBar.propTypes = {
  sponsorshipItems: PropTypes.array.isRequired,
  paymentType     : PropTypes.string,
  onCartAction    : PropTypes.func,
}
